import { TRequestFormStep } from '../../../types/requestForm';
import { isSensitiveFormFields } from '../../../utils/requestForm';

export interface IGetStepValueLabelProps {
  formValue: { [key: string]: unknown };
  fromStep: TRequestFormStep;
}

export const STEP_VALUE_LABEL_SEPARATOR = ';';

export function getStepValueLabel({ formValue, fromStep }: IGetStepValueLabelProps): string {
  return fromStep.question.fields
    .map<string>(({ name }) => {
      const value = formValue[name];

      if (isSensitiveFormFields(name) || !value) {
        return '';
      }

      return typeof value === 'string' ? value : JSON.stringify(value);
    })
    .join(STEP_VALUE_LABEL_SEPARATOR);
}
